<script>
import VBtn from 'vuetify/es5/components/VBtn'
export default {
  name: "YBtn",
  extends: VBtn,
  props: {
    event: {
      value: String,
      required: true
    },
    eventCount: {
      value: Number,
      required: false,
      default: 0
    },
    eventDuration: {
      value: Number,
      required: false,
      default: 0
    },
    eventParams: {
      value: Object,
      required: false,
      default: {}
    }
  },
  data: () => ({
  }),
  methods: {
    click (e) {
      // Do not edit below
      !this.retainFocusOnClick && !this.fab && e.detail && this.$el.blur()
      this.$emit('click', e)
      this.btnToggle && this.toggle()
      // Do not edit above

      this.handleAnalytics()
    },
    handleAnalytics () {
      let name = this.event
      let count = this.eventCount
      let duration = this.eventDuration
      let params = this.eventParams

      if (process.env.VUE_APP_ENV === 'test') {
        let paramsDisplay = ''
        Object.keys(params).forEach(k => {
          paramsDisplay += `${k}=${params[k]} `
        })
        console.log(`[ANALYTICS] y-btn clicked: web.${name} ${paramsDisplay}`)
      }
      let data = {
        name: 'web.' + name,
        device_id: this.$store.state.user.deviceId,
        user_id: this.$store.state.user.user ? this.$store.state.user.user.id : 0,
        company_id: this.$store.state.company.company ? this.$store.state.company.company.id : 0,
        count: count,
        duration: duration,
        params: params
      }
      this.$axios.post(`${process.env.VUE_APP_ANALYTICS_URL}/log`, data).catch(() => {})
    }
  }
}
</script>